import { useTranslation } from 'react-i18next';

export type Testimonial = {
  quote: string;
  author: string;
  role: string;
  avatar: string;
};

export const useTestimonials = () => {
  const { t } = useTranslation();

  const testimonialItems = t('home.testimonials.items', {
    returnObjects: true,
  }) as Testimonial[];

  const data = {
    label: t('home.testimonials.label'),
    title: t('home.testimonials.title'),
    testimonials: Array.isArray(testimonialItems) ? testimonialItems : [],
  };

  return { data };
};

export type TestimonialsProps = ReturnType<typeof useTestimonials>;
